import { FC } from "react";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { useTranslation } from "react-i18next";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";
import { permissionEntityAdapter } from "@/components/permissions/permissionEntityAdapter";

interface Props {
  title?: string;
}

const PermissionTable: FC<Props> = () => {
  const { t } = useTranslation();
  usePageHeading(t("permissions"));
  return (
    <GenericCrudTable
      allowColumnFiltering={true}
      showColumnFilterbyDefault={true}
      entity="permission"
      entityAdapter={permissionEntityAdapter}
      disallowDelete={true}
      columns={[
        { header: t("id"), accessorKey: "id", id: "id" },
        {
          header: t("name"),
          accessorKey: "name",
          id: "name",
          enableForCreate: true,
        },

        { header: t("codename"), accessorKey: "codename", id: "codename" },
        {
          header: t("type"),
          accessorKey: "content_type",
          id: "content_type",
          size: 40,
        },
      ]}
    />
  );
};

export default PermissionTable;
